import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // ✅ i18n
import './Terms.css';
import { API_BASE } from './apiConfig';

const Terms = () => {
  const { t, i18n } = useTranslation(); // ✅ i18n hook
  const [terms, setTerms] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    fetch(`${API_BASE}/api/settings`, {
      headers: {
        'ngrok-skip-browser-warning': 'true',
        'Accept': 'application/json'
      }
    })
      .then(res => res.json())
      .then(data => {
        // Ենթադրենք սերվերը վերադարձնում է տարբեր լեզուների համար տարբեր դաշտեր,
        // օրինակ՝ terms_content_hy, terms_content_en և այլն:
        // Եթե ոչ, օգտագործում ենք ընդհանուր դաշտը:
        const langContent = data[`terms_content_${i18n.language}`] || data.terms_content;
        if (langContent) {
          setTerms(langContent);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching terms:", err);
        setLoading(false);
      });
  }, [i18n.language]);

  // Ամսաթվի ֆորմատավորում ըստ լեզվի
  const formatDate = () => {
    const locales = { hy: 'hy-AM', ru: 'ru-RU', en: 'en-US' };
    return new Date().toLocaleDateString(locales[i18n.language] || 'en-US');
  };

  return (
    <div className="terms-outer-wrapper">
      <div className="terms-container">
        <div className="terms-card">
          <div className="terms-header">
            <h1>{t('terms_title')}</h1>
            <div className="gold-separator"></div>
            <p className="last-updated">{t('last_updated')} {formatDate()}</p>
          </div>

          <div className="terms-body">
            {loading ? (
              <div className="loading-spinner">{t('loading')}</div>
            ) : terms ? (
              <div className="terms-dynamic-content">
                {terms}
              </div>
            ) : (
              <div className="terms-static-content">
                <section>
                  <h2>{t('terms_sec1_title')}</h2>
                  <p>{t('terms_sec1_text')}</p>
                </section>

                <section>
                  <h2>{t('terms_sec2_title')}</h2>
                  <p>{t('terms_sec2_text')}</p>
                </section>

                <section>
                  <h2>{t('terms_sec3_title')}</h2>
                  <p>{t('terms_sec3_text')}</p>
                </section>
              </div>
            )}
          </div>

          <div className="terms-footer">
            <button className="back-btn-gold" onClick={() => window.history.back()}>
              {t('btn_back')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;